<ng-container *ngrxLet="activeLanguage$ as activeLanguage">
    <ng-container *ngIf="activeLanguage === 'pl'">
        <p>
            <strong>
                Bezzałogowe statki powietrzne zrewolucjonizują dostawy na obszarach podmiejskich, skracając czas transportu do minimum.
                Nowoczesne rozwiązania oparte o technologię dronową pojawią się w inżynierii, geodezji, akcjach poszukiwawczych i
                ratownictwie. Wiele branż zyska warunki do rozwoju na niespotykaną skalę.
            </strong>
        </p>

        <p>
            Polska Agencja Żeglugi Powietrznej, dzięki funduszom z Krajowego Programu Odbudowy, stworzy warunki do realizacji tej rewolucji.
            Zapewni również w jej ramach najwyższy poziom bezpieczeństwa operacji dronowych. Dodatkowo nowoczesne systemy monitorowania
            przestrzeni powietrznej przełożą się na lepszą integrację lotnictwa załogowego i bezzałogowego, otwierając zupełnie nowy
            rozdział we współdzieleniu nieba.
        </p>

        <p>
            Dzięki programowi realizowanemu przez Polską Agencję Żeglugi Powietrznej (PAŻP) w ramach Krajowego Planu Odbudowy (KPO) pod
            nazwą"Rozbudowa i wyposażenie centrów kompetencji (specjalistyczne ośrodki szkoleniowe, ośrodki wsparcia wdrożeń, centra
            monitorowania) oraz infrastruktura do zarządzania ruchem pojazdów bezzałogowych jako ekosystem innowacji" na terenie całej
            Polski pojawią się miejsca do wykonywania lotów dronów rodem z przyszłości – wszystkie oparte na wykorzystaniu nowoczesnych
            technologii dronowych tworzonych przez PAŻP.
        </p>

        <p>
            Spełniając te założenia Polska Agencja Żeglugi Powietrznej ogłosiła właśnie Konkurs do naboru podmiotów do współpracy przy
            wdrożeniu usług w ramach KPO, przeznaczony dla Jednostek Samorządu Terytorialnego (JST). Projekt obejmie m.in. budowę
            infrastruktury i rozwój technologii zwiększających możliwości realizacji usług z wykorzystaniem dronów.
        </p>

        <p>
            Projekt jest skierowany do szerokiego grona odbiorców, otwierając nowe możliwości zarówno dla biznesu, jak i społeczności
            lokalnych, Piloci i Operatorzy dronów mogą liczyć na realizację większego zakresu usług możliwych dzięki nowoczesnym
            rozwiązaniom dronowym a także na zwiększenie kwalifikacji. Przedsiębiorcy otrzymają nowe możliwości wykorzystania dronów w
            dostawach, inspekcjach, monitoringu i innych działaniach znacząco zwiększających konkurencyjność firm. Jednostki Samorządu
            Terytorialnego (JST) i inne podmioty publiczne będą mogły skorzystać z innowacyjnych narzędzi wspierających codzienne zadania
            administracyjne, co przełoży się na wzrost atrakcyjności miast i gmin, w tym na nowe miejsca pracy i rozwój gospodarczy. Projekt
            tym samym nie tylko otwiera drzwi do innowacji, ale także napędza rozwój lokalnych społeczności i gospodarki.
        </p>

        <p>
            Powyższe będzie możliwe dzięki utworzeniu sieci lokalnych Centrów Kompetencji (CK) wraz z rozwiązaniami technologicznymi
            umożliwiającymi wykonywanie w jednym wydzielonym fragmencie przestrzeni powietrznej (w obszarze przypisanym do każdego CK) wielu
            rodzajów lotów BSP w jednym czasie, w tym złożonych operacji prowadzonych poza zasięgiem wzroku (BVLOS). PAŻP planuje
            uruchomienie Centrów Kompetencji w 10 lokalizacjach, z czego 9 zostanie wyłonionych w drodze ogłoszonego właśnie konkursu
            skierowanego do Jednostek Samorządu Terytorialnego (JST).
        </p>

        <p>
            Zapraszamy przedstawicieli JST do wzięcia udziału w Konkursie, który będzie trwał do 16 lipca 2025 r. Realizacja projektu jest
            zaplanowana do 30 czerwca 2026 roku. Szczegółowe informacje znajdują się na stronie Krajowego Systemu Informacji Dronowej
            (KSID):
            <br />
            <a class="button-link" routerLink="/nrp/about-project" target="_blank">Informacje o projekcie</a>
            <br />
            <a class="button-link" routerLink="/nrp/competition" target="_blank">Informacje o konkursie</a>
        </p>

        <h4><u>Poniżej skrócone informacje o projekcie i konkursie.</u></h4>

        <p>
            Konkurs skierowany jest do Jednostek Samorządu Terytorialnego (JST). W ramach konkursu wyłonione zostanie na terenie Polski
            dziewięć lokalizacji, w których utworzone zostaną Centra Kompetencji. Konkurs trwa od 19.03.2025 r. do 16.07.2025 r. i jest
            podzielony na dwa etapy.
        </p>

        <p>
            Etap 1. służy jedynie weryfikacji, czy w danej lokalizacji istnieje możliwość utworzenia Centrum Kompetencji, zgodnie z
            założeniami projektu. W tym Etapie wymagane jest jedynie złożenie prostego wniosku, a PAŻP przeprowadzi analizę zgłoszenia oraz
            przekaże Uczestnikowi ewentualne wymagane modyfikacje w zgłoszeniu, aby ten mógł zostać zakwalifikowany do Etapu 2.
        </p>

        <p><strong>Składanie wniosków w konkursie w ramach Etapu 1 jest możliwe od 19.03.2025 r. do 08.05.2025 r.</strong></p>

        <p>
            Wnioski składane w Etapie 1 nie są wiążące (Uczestnik nie musi zgłaszać się do Etapu 2, jeśli otrzymał do niego kwalifikację).
            Wnioski będą rozpatrywane w ciągu kilku dni roboczych, dlatego zachęcamy do jak najszybszego aplikowania i pozyskania informacji
            zwrotnej, czy dana lokalizacja kwalifikuje się do Etapu 2. Dzięki temu, będą mieli Państwo więcej czasu na przygotowanie wniosku
            w Etapie 2.
        </p>

        <p>
            Etap 2 służy z kolei do weryfikacji potencjału zgłaszanych obszarów pod kątem atrakcyjności lokalizacji (popyt i podaż na
            usługi).
        </p>

        <p><strong>Składanie wniosków w konkursie w ramach Etapu 2 jest możliwe od 01.04.2025 r. do 30.06.2025 r.</strong></p>

        <p>
            Celem konkursu jest transparentne wybranie obszarów, w których zostaną wdrożone Centra Kompetencji. Kryteria konkursu zostały
            ukierunkowane na wybór lokalizacji najbardziej perspektywicznych pod kątem popytu na usługi dronowe w obszarze objętym
            działaniem Centrum Kompetencji, przy równoczesnym uwzględnianiu aspektów związanych z rzeczywistą możliwością realizacji lotów
            (m.in. dostępność przestrzeni powietrznej dla BSP, poziom ryzyka naziemnego). Równocześnie zagadnienia infrastrukturalne
            związane z organizacją środowiska technologicznego w obszarze Centrum Kompetencji będą również podlegały ocenie, jako jeden z
            istotnych elementów przy wyborze optymalnych lokalizacji.
        </p>

        <p>
            Każde Centrum Kompetencji (CK) składać się będzie co najmniej z obszaru geograficznego, w którym zostanie wdrożone cyfrowe
            środowisko technologiczne wraz ze stosownymi procedurami, pozwalające użytkownikom na realizację w sposób dynamiczny różnego
            rodzaju lotów BSP. Utworzone środowisko dostarczy możliwości dla szerszego wykorzystywania BSP w usługach związanych z branżą
            m.in transportową, gastronomiczną, ratunkową, medyczną, ochroną mienia, badawczą, geodezyjną czy rolniczą.
        </p>

        <p>
            Dodatkowo w niektórych CK utworzone zostaną Ośrodki Szkoleniowo-Poligonowe, będące miejscem szkoleń, demonstracji produktów i
            usług, łączące potrzeby rynku w zakresie popytu i podaży na produkty i usługi związane z rynkiem dronowym.
        </p>

        <p>
            Równocześnie w dziesiątym Centrum Kompetencji (utworzonym na terenach zarządzanych przez PAŻP) testowane będą wytwarzane przez
            Agencję nowe rozwiązania IT w zakresie koordynacji lotów BSP, w tym m.in. usługa rekonfiguracji przestrzeni powietrznej (DAR),
            obsługująca proces dynamicznego zarządzania przestrzenią powietrzną pomiędzy różnymi "właścicielami" stref.
        </p>
    </ng-container>
    <ng-container *ngIf="activeLanguage === 'en'">
        <p>
            <strong>
                Unmanned aerial vehicles will revolutionize deliveries in suburban areas, reducing transport time to a minimum. Modern
                solutions based on drone technology will appear in engineering, geodesy, search and rescue operations. Many industries will
                have the opportunity to develop on an unprecedented scale.
            </strong>
        </p>

        <p>
            The Polish Air Navigation Services Agency, thanks to funds from the National Recovery Plan, will create conditions for the
            implementation of this revolution. It will also ensure the highest level of safety for drone operations within its framework.
            Additionally, modern airspace monitoring systems will lead to better integration of manned and unmanned aviation, opening a
            completely new chapter in airspace sharing.
        </p>

        <p>
            Thanks to the program implemented by the Polish Air Navigation Services Agency (PANSA) under the National Recovery Plan (NRP)
            called "Expansion and equipping of competence centers (specialized training centers, implementation support centers, monitoring
            centers) and infrastructure for managing unmanned vehicle traffic as an innovation ecosystem", places for performing drone
            flights from the future will appear throughout Poland - all based on the use of modern drone technologies created by PANSA.
        </p>

        <p>
            In line with these objectives, the Polish Air Navigation Services Agency has just announced a competition for the recruitment of
            entities to cooperate in the implementation of services under the NRP, intended for Local Government Units (LGUs). The project
            will include, among others, the construction of infrastructure and the development of technologies increasing the possibilities
            of providing services using drones.
        </p>

        <p>
            The project is aimed at a wide range of recipients, opening new opportunities for both business and local communities. Drone
            pilots and operators can expect to provide a wider range of services possible thanks to modern drone solutions and to increase
            their qualifications. Entrepreneurs will receive new opportunities to use drones in deliveries, inspections, monitoring, and
            other activities greatly enhancing companies' competitiveness. Local government units (LGUs) and other public entities will be
            able to use innovative tools supporting daily administrative tasks, which will translate into increased attractiveness of cities
            and municipalities, including new jobs and economic development. The project thus not only opens the door to innovation but also
            drives the development of local communities and the economy.
        </p>

        <p>
            This will be possible thanks to the creation of a network of local Competence Centers (CC) along with technological solutions
            enabling the performance of various types of UAV flights in one designated airspace fragment (in the area assigned to each CC)
            at the same time, including complex operations conducted beyond visual line of sight (BVLOS). PANSA plans to launch Competence
            Centers in 10 locations, of which 9 will be selected through the announced competition aimed at Local Government Units (LGUs).
        </p>

        <p>
            We invite representatives of LGUs to participate in the competition, which will last until July 16, 2025. The project
            implementation is planned until June 30, 2026. Detailed information can be found on the National Drone Information System (NDIS)
            website:
            <br />
            <a class="button-link" routerLink="/nrp/about-project" target="_blank">Project information</a>
            <br />
            <a class="button-link" routerLink="/nrp/competition" target="_blank">Competition information</a>
        </p>

        <h4><u>Below is a summary of the project and competition information.</u></h4>

        <p>
            The competition is aimed at Local Government Units (LGUs). As part of the competition, nine locations will be selected in Poland
            where Competence Centers will be established. The competition runs from March 19, 2025, to July 16, 2025, and is divided into
            two stages.
        </p>

        <p>
            Stage 1 is only for verifying whether it is possible to establish a Competence Center in a given location, according to the
            project assumptions. In this stage, only a simple application is required, and PANSA will analyze the submission and provide the
            participant with any required modifications to the application so that it can qualify for Stage 2.
        </p>

        <p><strong>Submitting applications in the competition for Stage 1 is possible from March 19, 2025, to May 8, 2025.</strong></p>

        <p>
            Applications submitted in Stage 1 are not binding (the participant does not have to apply for Stage 2 if they qualify for it).
            Applications will be reviewed within a few business days, so we encourage you to apply as soon as possible and receive feedback
            on whether the location qualifies for Stage 2. This will give you more time to prepare the application for Stage 2.
        </p>

        <p>Stage 2 aims to assess the potential of the submitted areas based on their attractiveness (demand and supply for services).</p>

        <p><strong>Submitting applications in the competition for Stage 2 is possible from April 1, 2025, to June 30, 2025.</strong></p>

        <p>
            The aim of the competition is to transparently select areas where Competence Centers will be implemented. The competition
            criteria are focused on selecting the most promising locations in terms of demand for drone services in the area covered by the
            Competence Center, while also considering aspects related to the actual possibility of conducting flights (e.g., availability of
            airspace for UAVs, ground risk level). At the same time, infrastructural issues related to the organization of the technological
            environment in the Competence Center area will also be assessed as one of the important elements in selecting optimal locations.
        </p>

        <p>
            Each Competence Center (CC) will include at least one designated geographical area where a digital technological environment
            will be implemented along with appropriate procedures, allowing users to dynamically perform various types of UAV flights. The
            created environment will provide opportunities for wider use of UAVs in services related to, among others, the transport,
            catering, rescue, medical, property protection, research, geodetic, and agricultural industries.
        </p>

        <p>
            Additionally, in some CCs, Training and Testing Centers will be established, serving as places for training, product and service
            demonstrations, combining market needs in terms of demand and supply for products and services related to the drone market.
        </p>

        <p>
            At the same time, in the tenth Competence Center (established in areas managed by PANSA), new IT solutions for UAV flight
            coordination, including the airspace reconfiguration service (DAR), supporting the process of dynamic airspace management
            between different "owners" of zones, will be tested.
        </p>
    </ng-container>
</ng-container>
